import { TemplateElement, html, defineElement } from '@webtides/element-js';
import portionsStore from './recipe-ingredients-portion-store.js';
import style from './recipe-ingredients-portion-stepper.css';
import { svgUse } from '../../webresources-sources/js/util/icon.js';

/**
 * @property {number} portions
 * @property {PortionsStore} portionsStore
 */
export default class RecipeIngredientsPortionStepper extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            portions: 1,
            portionsStore,
        };
    }

    connected() {
        this.portionsStore.portions = this.portions;
    }

    events() {
        return {
            button: {
                click: (e) => {
                    const step = e.target.getAttribute('step');
                    if (step === '-' && this.portionsStore.portions > 1) {
                        this.portionsStore.portions--;
                    } else if (step === '+') {
                        this.portionsStore.portions++;
                    }
                    this.$refs.input.value = this.portionsStore.portions;
                },
            },
            input: {
                change: (e) => {
                    const input = e.target;
                    this.portionsStore.portions = parseInt(input.value);
                },
            },
        };
    }

    template() {
        return html`
            <div class="d-flex align-items-center gap-16 mb-8 mb-md-16">
                <button step="-" class="btn h4 mb-0" aria-label="Decrease portion count by one">-</button>
                <input ref="input" type="number" inputmode="numeric" min="1" step="1" value="${this.portionsStore.portions}" class="h2 mb-0" />
                <button step="+" class="btn h4 mb-0" aria-label="Increase portion count by one">+</button>
            </div>
            ${svgUse({ name: 'icon-stroke', cssClasses: 'icon-stroke mb-4' })}
            <div class="text-center">Portionen</div>
        `;
    }
}

defineElement('recipe-ingredients-portion-stepper', RecipeIngredientsPortionStepper);
